import React from 'react'
import trash from '../../../../assets/assesses/trash.svg'
import check from '../../../../assets/assesses/check.svg'
import cross from '../../../../assets/assesses/cross.svg'
import axios from '../../../../config/axios'

interface TenantValidationType {
  situation: string
  tenantId: number
  adminUserId: number
  onUpdate: () => void
}

const TenantValidation = ({ situation, tenantId, adminUserId, onUpdate }: TenantValidationType) => {
  
  const changeStatus = (tenantId: number, type: string): void => {
    axios
      .patch(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/tenant/${tenantId}/approve`, {
        approved: type,
      })
      .then((res) => {
        console.log(res)
        onUpdate()
      })
      .catch((err) => {
        console.error('Erro ao atualizar status do tenant:', err)
      })
  }

  const iconStyle = {
    cursor: 'pointer',
    marginRight: '8px',
    width: '20px',
    height: '20px',
  }

  const disabledStyle = {
    ...iconStyle,
    opacity: 0.3,
    cursor: 'not-allowed',
  }
  
  if(situation === 'approved'){
    return(
      <>
        <img src={check} alt="check" style={disabledStyle} />
        <img src={cross} alt="cross" style={iconStyle} onClick={() => changeStatus(tenantId, 'deactivate')} />
      </>
    )
  }
  if(situation === 'pendent' || situation === 'pending' || situation === 'deactivate'){
    return(
      <>
        <img src={check} alt="check" style={iconStyle} onClick={() => changeStatus(tenantId, 'approved')} />
      </>
    )
  }
  if(situation === 'blocked'){
    return(
      <>
        <img src={check} alt="check" style={iconStyle} onClick={() => changeStatus(tenantId, 'approved')} />
      </>
    )
  }
  return null;
}

export default TenantValidation
